/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-06-05 11:32:28
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2025-11-06 17:33:56
 * @FilePath: /qd-yunjing-web/src/store/user.ts
 * @Description: 这是默认设置,请设置`customMade`,
 */
import { defineStore } from 'pinia';
import {
  getLfUserMenusRequest,
  logout,
} from '@/api/modules/user';
import { getMenuConfig } from '@/api/modules/menu-config';
import { LocalStorageService } from '@/utils/storage';

import { entryMap, getAuthCodeToMicroAppMap } from '@/utils/constants';
import { useTenantStore } from '@/store/tenant';

import { menuList } from '@/config/menu-list';

type State = {
  userInfo: TypeObject,
  menus: TypeObject[],
  authKeys: string[],
  modelId: string,
  modelUrl: string,
  modelAnchorId: TypeObject[],
  cameraIcon:TypeObject
}

export const useUserStore = defineStore('_user', {
  state: (): State => ({
    userInfo: {},
    menus: [],
    authKeys: [],
    // 以下数据是普通页面和模型页面进行交互的变量，集中写在这里
    modelId: '',
    modelUrl: '',
    modelAnchorId: [],
    cameraIcon: {},
  }),
  actions: {
    getUserInfo(): Promise<TypeObject> {
      return new Promise((resolve, reject) => {
        getLfUserMenusRequest().then(({ data }: TypeObject) => {
          const userInfo = {
            authorization: data.authorization,
            loginName: data.loginName,
            loginTime: data.loginTime,
            userId: data.userId,
            userName: data.userName,
            realName: data.realName,
            jobCode: data.jobCode,
            currentTenantId: data.currentTenantId,
            currentTenantName: data.currentTenantName,
          };

          try {
            if ((window as any).MAIAAPM) {
              // userId变量为用户唯一识别id，举例：oa账号，手机号，用户名。
              (window as any).MAIAAPM.setUid(data.userName);
            }
          } catch (err) {
            console.log(err);
          }

          const functions = data.functions || [];
          if (!userInfo || !Object.keys(userInfo).length) { // 无用户信息
            this.setUserInfo({}); // 设置用户信息

            resolve({ menus: [], authKeys: [] });
          } else if (functions.length === 0) { // 无权限code信息
            this.setUserInfo(userInfo); // 设置用户信息

            resolve({ menus: [], authKeys: [] });
          } else {
            // 获取所有的authKeys，包括组件下面配置的操作
            const authKeys: string[] = [];
            functions.forEach((func: TypeObject) => {
              authKeys.push(func.code);
              if (func.operations && func.operations.length) {
                func.operations.forEach((op: string) => {
                  authKeys.push(`${func.code}.${op}`);
                });
              }
            });
            this.setAuthKeys(authKeys);
            this.setMenus(functions); // am中配置的菜单和组件
            this.setUserInfo(userInfo); // 设置用户信息

            const modules = data.modules;
            // 从租户 store 获取权限编码前缀
            const tenantStore = useTenantStore();
            const fmPermission = tenantStore.fmPermission;
            const authCodeToMicroAppMap = getAuthCodeToMicroAppMap(fmPermission);

            if (modules.length === 1
              || (modules.length === 2
                && modules.includes(`${fmPermission}EMS`)
                && modules.includes(`${fmPermission}OPERATION`))
            ) { // 如果用户只有一个权限code，跳转至对应的子应用
              const redirectPath = `${entryMap[authCodeToMicroAppMap[modules[0]]]}`;
              window.location.replace(redirectPath);
            }

            resolve({
              menus: functions,
              authKeys,
            });
          }
        }).catch(() => {
          resolve({
            menus: [],
            authKeys: [],
          });
          reject(new Error('获取用户权限信息失败'));
        });
      });
    },
    getMenuList(): Promise<TypeObject> {
      return new Promise((resolve, reject) => {
        // 从租户 store 获取 appCode
        const tenantStore = useTenantStore();
        const expandInfo = tenantStore.currentTenant?.expandInfo;
        let appCode = 'C4YUNJ';
        if (typeof expandInfo === 'string') {
          try {
            appCode = JSON.parse(expandInfo).appCode || 'C4YUNJ';
          } catch {
            // 解析失败使用默认值
          }
        } else if (expandInfo?.appCode) {
          appCode = expandInfo.appCode;
        }

        getMenuConfig(appCode).then(({ data }: TypeObject) => {
          const menus = (data?.menus || []).length ? data.menus : menuList;
          resolve({
            menus,
          });
        }).catch(() => {
          resolve({
            menus: menuList,
          });
        });
      });
    },
    logout(): Promise<TypeObject> {
      return new Promise((resolve, reject) => {
        logout().then(({ loginUrl }: TypeObject) => {
          LocalStorageService.clear();
          resolve({
            loginUrl,
          });
        }).catch(() => {
          reject(new Error('退出登录失败'));
        });
      });
    },
    setUserInfo(info: TypeObject) {
      this.userInfo = info;
      LocalStorageService.set('_user_info', info);
    },
    setModelId(data: string) {
      this.modelId = data;
    },
    setModelUrl(url: string) {
      this.modelUrl = url;
    },
    setMenus(data: TypeObject[]) {
      this.menus = data;
    },
    setAuthKeys(data: string[]) {
      this.authKeys = data;
    },
    // 设置modelAnchorId
    setAnchorId(info: any) {
      if (info) {
        this.modelAnchorId.push(info);
      } else {
        this.modelAnchorId = [];
      }
    },
    setCameraIcon(info: any) {
      if (info) {
        this.cameraIcon = info;
      }
    },
  },
});
